import { useTranslation } from 'react-i18next'

import { Modal, ModalBody, ModalContent, ModalHeader, ModalTitle } from '@/components/ui/Modal'
import type { WidgetOverviewRow } from '@/hooks/api/useWidgets'
import { BusinessProfileForm } from '@/pages/assistants/components/integrations/BusinessProfileForm'

interface WidgetBusinessProfileModalProps {
  row: WidgetOverviewRow | null
  onClose: () => void
}

export function WidgetBusinessProfileModal({ row, onClose }: WidgetBusinessProfileModalProps) {
  const { t } = useTranslation()
  const base = 'resources.widgets.business_profile'

  return (
    <Modal isOpen={!!row} onOpenChange={(isOpen) => !isOpen && onClose()} size="3xl">
      <ModalContent>
        <ModalHeader onClose={onClose} bordered={false}>
          <ModalTitle>{t(`${base}.title`, { assistant: row?.assistant_name ?? '' })}</ModalTitle>
        </ModalHeader>
        <ModalBody className="max-h-[calc(100vh-7rem)] overflow-y-auto pt-2">
          {row && <BusinessProfileForm assistantId={row.assistant_id} defaultOpen />}
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
